import { format, parse, isValid } from "date-fns";

export function formatDateString(dateStr: string): string {
    if (dateStr !== '') {
        return format(
            parse(dateStr, "yyyy-MM-dd", new Date()),
            "dd/MM/yyyy"
        );
    }
    return '';
}

export const formatDateToISO = (date: Date | null): string => {
    if (date !== null && isValid(date) && date.getFullYear() >= 1900) {
        return format(date, "yyyy-MM-dd");
    }
    return '';
};

export function parseDate(dateStr: string): Date | null {
    try {
        if (dateStr !== '') {
            return parse(dateStr, 'yyyy-MM-dd', new Date())
        }

        return null;
    } catch (e) {
        console.warn("Ignoring invalid date: ", e);
    }

    return null;
}

export function isValidDate(d: Date | null) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return d instanceof Date && isFinite(d)
}
